import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-delivery-perf-fleet-business-grp-trips',
    templateUrl: './delivery-perf-fleet-business-grp-trips.component.html',
    styleUrl: './delivery-perf-fleet-business-grp-trips.component.css',
})
export class DeliveryPerfFleetBusinessGrpTripsComponent implements OnInit {
    public gridId = 164;
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Request Delivery Performance by Fleet & Business Group - Trips';
    public gridSource: any;

    constructor(
        public route: ActivatedRoute,
        public reportService: RailtracReportsService,
        public pageService: PageService,
    ) {}

    ngOnInit() {
        this.pageService.setHeader(this.pageHeader);

        const ormIds = this.route.snapshot.queryParamMap.get('ormIds') ?? '';

        this.gridSource = this.reportService.CreateAspNetDatastore(
            this.apiCall,
            this.gridId.toString(),
            null,
            null,
            null,
            { ormIds },
        );
    }
}
